export const TYPES_LEVELS = { ONE: 1, THREE: 3, TWO: 2 }
